export { renderTabList_unstable as renderTabList } from '@fluentui/react-tabs';
